(() => {
  function init(root = document) {
    root.querySelectorAll('.nv-menu-toggle').forEach(toggle => {
      if (toggle.dataset.ready) return; toggle.dataset.ready = 'true';
      const header = toggle.closest('.nv-header');
      toggle.addEventListener('click', () => setMobileMenu(header, !header.classList.contains('nv-nav-open')));
    });
    root.querySelectorAll('.nv-menu').forEach(menu => {
      if (menu.dataset.ready) return; menu.dataset.ready = 'true';
      menu.addEventListener('toggle', () => { if (menu.open) document.querySelectorAll('.nv-menu').forEach(other => { if (other !== menu) other.open = false; }); });
    });
    root.querySelectorAll('[data-nv-catalog]').forEach(catalog => {
      if (catalog.dataset.ready) return; catalog.dataset.ready = 'true';
      const grid = catalog.querySelector('.nv-product-grid');
      const cards = Array.from(grid.querySelectorAll('.nv-product'));
      const filters = Array.from(catalog.querySelectorAll('[data-filter]'));
      const count = catalog.querySelector('.nv-result-count');
      function filter(value) {
        if (!filters.length) return;
        const valid = filters.some(b => b.dataset.filter === value) ? value : 'all';
        filters.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.filter === valid)));
        cards.forEach(c => c.hidden = valid !== 'all' && c.dataset.category !== valid);
        const n = cards.filter(c => !c.hidden).length;
        if (count) count.textContent = n ? `${n} pillow${n === 1 ? '' : 's'} to explore` : 'No pillows in this category yet. Explore another category.';
      }
      filters.forEach(b => b.addEventListener('click', () => { filter(b.dataset.filter); history.replaceState(null, '', location.pathname + location.search + '#' + b.dataset.filter); }));
      window.addEventListener('hashchange', () => filter(location.hash.slice(1)));
      filter(location.hash.slice(1) || 'all');
      catalog.querySelector('[data-nv-sort]')?.addEventListener('change', e => {
        const sorted = [...cards];
        if(e.target.value === 'price-asc') sorted.sort((a,b) => Number(a.dataset.price) - Number(b.dataset.price));
        if(e.target.value === 'price-desc') sorted.sort((a,b) => Number(b.dataset.price) - Number(a.dataset.price));
        if(e.target.value === 'title') sorted.sort((a,b) => a.dataset.title.localeCompare(b.dataset.title));
        sorted.forEach(c => grid.appendChild(c));
      });
    });
    root.querySelectorAll('[data-nv-quiz]').forEach(form => {
      if (form.dataset.ready) return; form.dataset.ready = 'true';
      const result = form.parentElement.querySelector('[data-nv-result]');
      form.addEventListener('submit', event => {
        event.preventDefault(); if (!form.reportValidity()) return;
        const a = Object.fromEntries(new FormData(form));
        let slot, why;
        if(a.need === 'body') { slot = 'embrace'; why = 'You want something to hug or lounge with. A full-length body pillow is a useful starting point.'; }
        else if(a.need === 'knee') { slot = 'balance'; why = 'You are looking for support between your knees. Explore this compact, shaped knee pillow.'; }
        else if(a.need === 'lounge') { slot = 'elevate'; why = 'You want a little elevation for reading or resting. A wedge shape is worth exploring.'; }
        else if(a.need === 'adjust' || a.feel === 'adjust' || a.position === 'stomach' || a.position === 'mixed') { slot = 'adapt'; why = 'Adjustable fill lets you experiment with loft and feel. This is a useful starting point when you change positions or want more control over pillow height.'; }
        else if(a.need === 'cool') { slot = 'cloud'; why = 'You prefer a cooler-feeling pillow surface. Explore this cool-touch option and compare its dimensions with your current pillow.'; }
        else if(a.need === 'neck' && a.feel === 'structured') { slot = 'align'; why = 'You prefer a shaped, supportive surface. A contour pillow is a useful starting point for exploring that feel.'; }
        else { slot = 'adapt'; why = 'You prefer a more yielding feel. Adjustable shredded fill lets you try different amounts until the loft feels comfortable.'; }
        let primary;
        result.querySelectorAll('.nv-product').forEach(c => { c.hidden = c.dataset.slot !== slot; if (!c.hidden) primary = c; });
        result.querySelector('[data-result-title]').textContent = primary ? primary.dataset.title : 'Explore your comfort options';
        result.querySelector('[data-result-copy]').textContent = primary ? why : 'That pillow is currently unavailable in the catalog. Explore the other pillows in our shop or contact us for help choosing.';
        result.hidden = false; form.hidden = true; result.focus(); result.scrollIntoView({behavior:'smooth',block:'start'});
      });
      result.querySelector('[data-quiz-reset]').addEventListener('click', () => { form.reset(); result.hidden = true; form.hidden = false; form.querySelector('input').focus(); });
    });
  }
  function setMobileMenu(header, open) {
    if (!header) return;
    const toggle = header.querySelector('.nv-menu-toggle');
    header.classList.toggle('nv-nav-open', open);
    if (toggle) { toggle.setAttribute('aria-expanded', String(open)); toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); }
    if (!open) header.querySelectorAll('.nv-menu[open]').forEach(m => { m.open = false; });
  }
  window.matchMedia('(min-width: 751px)').addEventListener('change', e => { if (e.matches) document.querySelectorAll('.nv-header.nv-nav-open').forEach(h => setMobileMenu(h, false)); });

  // Keep the bag count current and confirm additions (the custom header has no cart drawer).
  let lastCount = null;
  let toastTimer;
  function readCount() { const el = document.querySelector('.nv-cart span'); return el ? Number(el.textContent) || 0 : 0; }
  function showToast() {
    let toast = document.querySelector('.nv-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'nv nv-toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite');
      const text = document.createElement('span'); text.textContent = 'Added to your bag';
      const link = document.createElement('a'); link.className = 'nv-toast-link'; link.textContent = 'View bag →';
      link.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart';
      const close = document.createElement('button'); close.type = 'button'; close.className = 'nv-toast-close'; close.setAttribute('aria-label', 'Dismiss'); close.textContent = '×';
      close.addEventListener('click', () => toast.classList.remove('is-visible'));
      toast.append(text, link, close); document.body.appendChild(toast);
    }
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    clearTimeout(toastTimer); toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 5000);
  }
  function refreshCart() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        if (lastCount === null) lastCount = readCount();
        document.querySelectorAll('.nv-cart span').forEach(el => { el.textContent = cart.item_count > 0 ? cart.item_count : ''; });
        const cartLink = document.querySelector('.nv-cart');
        if (cart.item_count > lastCount) {
          if (cartLink) { cartLink.classList.remove('nv-cart-bump'); void cartLink.offsetWidth; cartLink.classList.add('nv-cart-bump'); }
          showToast();
        }
        lastCount = cart.item_count;
      })
      .catch(() => {});
  }
  document.addEventListener('cart:update', refreshCart);
  // Refresh when a shopper returns with the back button (page restored from cache).
  window.addEventListener('pageshow', e => { if (e.persisted) { lastCount = null; refreshCart(); } });

  document.addEventListener('click', e => document.querySelectorAll('.nv-menu[open]').forEach(m => { if (!m.contains(e.target)) m.open = false; }));
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const openMenus = document.querySelectorAll('.nv-menu[open]');
    if (openMenus.length) { openMenus.forEach(m => { m.open = false; m.querySelector('summary').focus(); }); return; }
    document.querySelectorAll('.nv-header.nv-nav-open').forEach(h => { setMobileMenu(h, false); h.querySelector('.nv-menu-toggle')?.focus(); });
  });
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
